import React from 'react';
import Error from './Error.js';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  
  componentDidCatch(error, errorInfo) {
    console.log(`ErrorBoundary: ${error}`)
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }
  
  render() {
    if (this.state.errorInfo) {
      return (
        <Error title="Wystąpił błąd"></Error>
        //           {/* {this.state.error && this.state.error.toString()}
        //           {this.state.errorInfo.componentStack} */}
      );
    }
    return this.props.children;
  }  
}

export default ErrorBoundary;